import React, { useEffect, useState } from "react";





const Spinner = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simule le chargement, ici tu peux mettre ton fetch ou autre
    const timer = setTimeout(() => {
      setLoading(false); // stop le spinner
    }, 1000); // 1 seconde pour l'exemple

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {loading && (
        <div id="spinner" className="spinner">
          <div className="spinner-content"></div>
        </div>
      )}
      {!loading && (
        <div className="content">
          {/* Ton contenu principal */}
        </div>
      )}
    </>
  );
};

export default Spinner;




